// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.combo-box__icon_cf2edd7f {
  font-size: 1.584rem;
}
.combo-box__item_default_cf2edd7f {
  color: #657682;
  font-style: italic;
}
.combo-box__meta-data_cf2edd7f {
  text-transform: capitalize;
  color: #84919b;
  font-weight: 600;
  white-space: nowrap;
}
.combo-box_input_cf2edd7f {
  text-overflow: ellipsis;
  cursor: pointer;
}
.item__check_cf2edd7f {
  margin-left: 1.334rem;
  visibility: hidden;
}
.item__check_cf2edd7f.selected_cf2edd7f {
  visibility: visible;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"combo-box__icon": `combo-box__icon_cf2edd7f`,
	"combo-box__item_default": `combo-box__item_default_cf2edd7f`,
	"combo-box__meta-data": `combo-box__meta-data_cf2edd7f`,
	"combo-box_input": `combo-box_input_cf2edd7f`,
	"item__check": `item__check_cf2edd7f`,
	"selected": `selected_cf2edd7f`
};
export default ___CSS_LOADER_EXPORT___;
